import React from "react";

const RISK_BADGE = {
  HIGH:   { bg: "#fef2f2", color: "#a32d2d", label: "HIGH"   },
  MEDIUM: { bg: "#faeeda", color: "#633806", label: "MEDIUM" },
  LOW:    { bg: "#e1f5ee", color: "#0f6e56", label: "LOW"    },
};

const EquipmentCard = ({ name, risk, desc }) => {
  const badge = RISK_BADGE[risk] || RISK_BADGE.LOW;
  return (
    <div style={{
      background: "#fff", border: "0.5px solid #e2e4e8",
      borderRadius: 8, padding: "12px 14px",
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
        <span style={{ fontSize: 13, fontWeight: 500, color: "#1a1e2e" }}>{name}</span>
        <span style={{
          fontSize: 10, fontWeight: 600, padding: "2px 9px",
          borderRadius: 20, background: badge.bg, color: badge.color,
          letterSpacing: 0.3,
        }}>
          {badge.label}
        </span>
      </div>
      <p style={{ fontSize: 11, color: "#8a909e", lineHeight: 1.55, margin: 0 }}>{desc}</p>
    </div>
  );
};

const FleetRiskByEquipment = ({ equipment }) => {
  const data = equipment || [
    { name: "Main Engine",   risk: "HIGH",   desc: "Highest fleet exposure and strongest impact on reliability." },
    { name: "Turbocharger",  risk: "MEDIUM", desc: "Watch fouling, air path restriction and efficiency drift." },
    { name: "Aux Engines",   risk: "MEDIUM", desc: "Fuel pump calibration and performance drift need follow-up." },
    { name: "Boiler",        risk: "LOW",    desc: "Stable overall, but clear tuning opportunity remains." },
  ];

  return (
    <div style={{
      background: "#f5f6f8", border: "0.5px solid #e2e4e8",
      borderRadius: 10, padding: 16, height: "100%",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5a6070" strokeWidth="2">
          <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
          <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
        </svg>
        <span style={{ fontSize: 14, fontWeight: 500, color: "#1a1e2e" }}>Fleet Risk By Equipment</span>
      </div>
      <p style={{ fontSize: 11, color: "#8a909e", marginBottom: 14, lineHeight: 1.5 }}>
        Users can see which machinery groups are driving risk without opening detailed tables.
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        {data.map((eq, i) => <EquipmentCard key={i} {...eq} />)}
      </div>
    </div>
  );
};

export default FleetRiskByEquipment;